import { Button, Typography } from "@mui/material";
import React, { useState } from "react";
import YImg from "../../assets/images/VectorMail.svg";
import MImg from "../../assets/images/VectorYtube.svg";
import "../../assets/css/scientist.css";

export const HomeButtons = ({footerButtons=[]}) => {
  return (
    <div className="">
      {footerButtons.map((button, index) => (
        <Button
          key={index}
          className="flex justify-center h-20 p-0 my-5 text-white rounded-lg w-80"
          style={{ background: "#1E3F52" }}
        >
        <a
            href={button.action}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-full h-full"
          >
            <img
              className="p-0 mx-3"
              src={button.label.includes("@") ? YImg : MImg} // YImg for email, MImg for YouTube
              alt="img"
            />
            <Typography fontSize={12}>{button.label} </Typography>
          </a>
        </Button>
      ))}
    </div>
  );
};
